<template>
  <div class="modal fade" id="taskMadeModal" tabindex="-1" ref="modal" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg">
        <div class="modal-header border-0 p-4" :class="customerServiceId ? 'bg-linked' : 'bg-new'">
          <div class="d-flex align-items-center">
            <div class="icon-box-modal me-3">
              <i class="fas" :class="customerServiceId ? 'fa-link' : 'fa-plus'"></i>
            </div>
            <div>
              <h5 class="modal-title fw-bold text-white mb-0">
                {{ customerServiceId ? `Ticket #${customerServiceId}` : 'Novo Lançamento' }}
              </h5>
              <p class="mb-0 text-white opacity-75 small">
                {{ customerServiceId ? 'Vinculado ao atendimento em curso' : 'Registre sua atividade manual' }}
              </p>
            </div>
          </div>
          <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
        </div>

        <div class="modal-body p-4">
          <form @submit.prevent="submit" class="row gy-4">
            <div class="col-md-4">
              <label class="form-label-custom">Data da Atividade</label>
              <date-picker 
                v-model="localDate" 
                format="DD/MM/YYYY" 
                value-type="format"
                placeholder="Selecione..."
                :clearable="false"
              />
            </div>

            <div class="col-md-4">
              <label class="form-label-custom">Horário de Início</label>
              <input 
                ref="started_at"
                class="form-control custom-input" 
                v-mask="'##:##'" 
                v-model="form.started_at" 
                placeholder="00:00" 
              />
            </div>

            <div class="col-md-4">
              <label class="form-label-custom">Horário de Fim</label>
              <input 
                ref="finished_at"
                class="form-control custom-input" 
                v-mask="'##:##'" 
                v-model="form.finished_at" 
                placeholder="00:00" 
              />
            </div>

            <div class="col-md-6">
              <label class="form-label-custom">Atividade</label>
              <v-select 
                :reduce="t => t.id" 
                placeholder="Selecione a atividade..." 
                label="name"
                v-model="form.task_id" 
                :options="tasks"
              />
            </div>

            <div class="col-md-6">
              <label class="form-label-custom">Classificação</label>
              <v-select 
                :reduce="t => t.id" 
                placeholder="Selecione o tipo..." 
                label="name"
                v-model="form.task_type_id" 
                :options="taskTypes"
              />
            </div>

            <div class="col-md-12">
              <label class="form-label-custom">Cliente</label>
              <v-select 
                :reduce="c => c.id" 
                placeholder="Selecione o cliente..." 
                label="name"
                v-model="form.customer_id" 
                :options="customers"
                :disabled="Boolean(customerServiceId)"
              />
            </div>

            <div class="col-md-12">
              <label class="form-label-custom">Observação / Descritivo</label>
              <textarea 
                class="form-control custom-input" 
                v-model="form.note" 
                rows="3"
                placeholder="O que foi desenvolvido nesta etapa?"
              ></textarea>
            </div>

            <div v-if="allErrors.length" class="col-12">
              <div class="alert alert-danger border-0 shadow-sm rounded-4 py-3">
                <div class="d-flex align-items-center mb-2">
                  <i class="fas fa-exclamation-circle me-2"></i>
                  <span class="fw-bold small text-uppercase letter-spacing-1">Por favor, corrija os erros abaixo:</span>
                </div>
                <ul class="mb-0 ps-4 small fw-bold">
                  <li v-for="(error, index) in allErrors" :key="index">
                    {{ error }}
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer border-0 p-4 bg-white">
          <button type="button" class="btn btn-light px-4 fw-bold text-muted" @click="closeModal">
            Cancelar
          </button>
          <button type="button" class="btn btn-success px-5 fw-bold shadow-sm" @click="submit" :disabled="saving">
            <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
            <i v-else class="fas fa-save me-2"></i> {{ saving ? 'Salvando...' : 'Salvar Registro' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import DatePicker from 'vue2-datepicker'
import vSelect from 'vue-select'

export default {
  name: 'TaskMadeFormModal',
  components: { DatePicker, vSelect },
  props: {
    tasks: Array,
    taskTypes: Array,
    customers: Array
  },
  data() {
    return {
      saving: false,
      localDate: '',
      customerServiceId: null,
      errors: {},
      form: {
        started_at: '',
        finished_at: '',
        task_id: null,
        task_type_id: null,
        customer_id: null,
        note: ''
      }
    }
  },
  computed: {
    allErrors() {
      return Object.values(this.errors).flat()
    }
  },
  methods: {
    open(data = null, isTicket = false) {
      this.errors = {}
      if (isTicket) {
        this.populateFromTicket(data)
      } else if (data) {
        this.populate(data)
      } else {
        this.resetForm()
      }
      $(this.$refs.modal).modal('show')
    },
    closeModal() {
      $(this.$refs.modal).modal('hide')
    },
    onDateChange() {
      this.$emit('date-changed', this.localDate)
    },
    setStartedAt(time) {
      this.form.started_at = time
    },
    populateFromTicket(ticket) {
      this.customerServiceId = ticket.id
      this.form.note = ticket.note || ''
      this.form.customer_id = ticket.customer_id
      this.form.task_id = ticket.task_id
      this.form.task_type_id = ticket.task_type_id
      this.form.started_at = ''
      this.form.finished_at = ''
      this.localDate = this.formatDateBr(new Date())
    },
    populate(task) {
      this.customerServiceId = task.customer_service_id || null
      this.form.started_at = ''
      this.form.finished_at = ''
      this.localDate = this.formatDateBr(new Date(task.made_at))
      this.form.note = task.note || ''
      this.form.customer_id = task.customer.data.id
      this.form.task_id = task.task.data.id
      this.form.task_type_id = task.task_type.data.id
    },
    resetForm() {
      this.errors = {}
      this.customerServiceId = null
      this.localDate = this.formatDateBr(new Date())
      this.form = {
        started_at: this.form.finished_at || '',
        finished_at: '',
        task_id: null,
        task_type_id: null,
        customer_id: null,
        note: ''
      }
    },
    async submit() {
      this.saving = true
      try {
        const payload = {
          ...this.form,
          made_at: this.convertBrToIso(this.localDate)
        }
        if (this.customerServiceId) {
          payload.customer_service_id = this.customerServiceId
        }

        await axios.post('/api/tasks_made', payload)
        this.$emit('saved')
        this.resetForm()
        this.closeModal()
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors
        }
        this.$toast.error('Erro ao salvar lançamento. Verifique os campos.')
      } finally {
        this.saving = false
      }
    },
    formatDateBr(date) {
      const d = new Date(date)
      return `${("0" + d.getDate()).slice(-2)}/${("0" + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()}`
    },
    convertBrToIso(dateStr) {
      if (!dateStr) return null
      const parts = dateStr.split('/')
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`
      }
      return dateStr
    }
  }
}
</script>

<style scoped lang="sass">
.bg-new
  background: linear-gradient(135deg, #00b894 0%, #00cec9 100%)
.bg-linked
  background: linear-gradient(135deg, #f1c40f 0%, #f39c12 100%)

.icon-box-modal
  width: 45px
  height: 45px
  background: rgba(255, 255, 255, 0.2)
  border-radius: 12px
  display: flex
  align-items: center
  justify-content: center
  i
    color: white
    font-size: 1.25rem

.form-label-custom
  color: #636e72
  font-weight: 700
  font-size: 0.75rem
  text-transform: uppercase
  letter-spacing: 0.5px
  margin-bottom: 8px
  display: block

.custom-input
  border-radius: 10px
  border: 2px solid #dfe6e9
  padding: 10px 15px
  font-size: 0.9rem
  transition: all 0.2s
  &:focus
    border-color: #00b894
    box-shadow: 0 0 0 4px rgba(0, 184, 148, 0.1)

.v-select
  --vs-border-color: #dfe6e9
  --vs-border-radius: 10px
  --vs-font-size: 0.9rem
  background: white

  ::v-deep .vs__dropdown-toggle
    border: 2px solid #dfe6e9
    border-radius: 10px
    height: 45px
    padding: 0 8px

  ::v-deep .vs__dropdown-menu
    z-index: 1060 !important
    position: absolute !important
    background: white
    border: 2px solid #dfe6e9
    border-radius: 10px
    margin-top: 4px
    box-shadow: 0 10px 25px rgba(0,0,0,0.1)
    padding: 5px 0

  ::v-deep .vs__dropdown-option
    padding: 10px 15px
    font-size: 0.85rem
    color: #2d3436
    &:hover, &.vs__dropdown-option--highlight
      background: #00b894
      color: white

.modal-body
  overflow: visible !important

.modal-content
  overflow: visible !important

.mx-datepicker
  width: 100% !important
  display: block
  
  ::v-deep .mx-input
    border: 2px solid #dfe6e9
    border-radius: 10px
    height: 45px
    box-shadow: none
    font-size: 0.9rem
    padding: 10px 15px
    background: white

  ::v-deep .mx-icon-calendar
    top: 50%
    transform: translateY(-50%)
    right: 12px

  ::v-deep .mx-datepicker-popup
    z-index: 1060 !important

.btn-success
  border-radius: 12px
  background: #00b894
  border: none
  &:hover
    background: #00a383

.btn-light
  border-radius: 12px

.alert-danger
  background-color: rgba(255, 71, 87, 0.1)
  color: #ff4757

.letter-spacing-1
  letter-spacing: 1px
</style>
